// extracted by mini-css-extract-plugin
module.exports = {"add-btn":"_1iBxHIg1qX","btn-icon":"_2L4u3Grkbt"};